import React from 'react'

export interface IntegrationPlatform {
  key: string,
  title: string,
  data: {
    fields: {
      key: string,
      label: string,
      required: boolean,
    }[],
    component?: (props: any) => React.JSX.Element,
  },
}

const integrationPlatforms: IntegrationPlatform[] = [
  {
    key: 'my_property_pass',
    title: 'My Property Pass',
    data: {
      fields: [
        {
          key: 'api_key',
          label: 'API Key',
          required: true,
        },
      ],
    },
  },
]

export default integrationPlatforms
